/**
 * @generated SignedSource<<271951a075ced8071af220ca382b07cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type headerOnelineMenuStyleQuery$data = {
  readonly styleOnelineMenu: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly " $fragmentSpreads": FragmentRefs<"entityLink" | "sectionStyleHeaderMenuItem">;
        };
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "headerOnelineMenuStyleQuery";
};
export type headerOnelineMenuStyleQuery$key = {
  readonly " $data"?: headerOnelineMenuStyleQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"headerOnelineMenuStyleQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "headerOnelineMenuStyleQuery",
  "selections": [
    {
      "alias": "styleOnelineMenu",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "name": "scmp_pwa_oneline_menu_style"
          }
        }
      ],
      "concreteType": "Queue",
      "kind": "LinkedField",
      "name": "queue",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 6
            }
          ],
          "concreteType": "QueueItemConnection",
          "kind": "LinkedField",
          "name": "items",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "QueueItemsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "entityLink"
                        },
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "sectionStyleHeaderMenuItem"
                        }
                      ],
                      "type": "Section",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "items(first:6)"
        }
      ],
      "storageKey": "queue(filter:{\"name\":\"scmp_pwa_oneline_menu_style\"})"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "96f7a4b59d95535368b9cea01e32e923";

export default node;
